import { Modal, ModalBody, ModalFooter, ModalHeader } from '../modal'
import ButtonControl from '../button-control'

const DraftDeleteConfirmationModal = (props) => {
  const { enableModal, onClose, onDelete } = props

  return (
    <Modal isOpen={enableModal} size='medium'>
      <ModalHeader title='Delete draft?' onClose={onClose} />
      <ModalBody>
        If you delete a draft, it's gone for good.
      </ModalBody>
      <ModalFooter>
        <ButtonControl title='Delete' variant='danger' onClick={onDelete} class='qa-delete' />
        <ButtonControl title='Cancel' onClick={onClose} />
      </ModalFooter>
    </Modal>
  )
}

export default DraftDeleteConfirmationModal
